/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type RevealRiskResultPayloadSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevealRiskResultPayloadSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevealRiskResultPayloadSecurity = {
  option1?: RevealRiskResultPayloadSecurityOption1 | undefined;
  option2?: RevealRiskResultPayloadSecurityOption2 | undefined;
};

export type RevealRiskResultPayloadRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type RevealRiskResultPayloadSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevealRiskResultPayloadSecurityOption1$outboundSchema:
  z.ZodMiniType<
    RevealRiskResultPayloadSecurityOption1$Outbound,
    RevealRiskResultPayloadSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function revealRiskResultPayloadSecurityOption1ToJSON(
  revealRiskResultPayloadSecurityOption1:
    RevealRiskResultPayloadSecurityOption1,
): string {
  return JSON.stringify(
    RevealRiskResultPayloadSecurityOption1$outboundSchema.parse(
      revealRiskResultPayloadSecurityOption1,
    ),
  );
}

/** @internal */
export type RevealRiskResultPayloadSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevealRiskResultPayloadSecurityOption2$outboundSchema:
  z.ZodMiniType<
    RevealRiskResultPayloadSecurityOption2$Outbound,
    RevealRiskResultPayloadSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revealRiskResultPayloadSecurityOption2ToJSON(
  revealRiskResultPayloadSecurityOption2:
    RevealRiskResultPayloadSecurityOption2,
): string {
  return JSON.stringify(
    RevealRiskResultPayloadSecurityOption2$outboundSchema.parse(
      revealRiskResultPayloadSecurityOption2,
    ),
  );
}

/** @internal */
export type RevealRiskResultPayloadSecurity$Outbound = {
  Option1?: RevealRiskResultPayloadSecurityOption1$Outbound | undefined;
  Option2?: RevealRiskResultPayloadSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevealRiskResultPayloadSecurity$outboundSchema: z.ZodMiniType<
  RevealRiskResultPayloadSecurity$Outbound,
  RevealRiskResultPayloadSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevealRiskResultPayloadSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevealRiskResultPayloadSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revealRiskResultPayloadSecurityToJSON(
  revealRiskResultPayloadSecurity: RevealRiskResultPayloadSecurity,
): string {
  return JSON.stringify(
    RevealRiskResultPayloadSecurity$outboundSchema.parse(
      revealRiskResultPayloadSecurity,
    ),
  );
}

/** @internal */
export type RevealRiskResultPayloadRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const RevealRiskResultPayloadRequest$outboundSchema: z.ZodMiniType<
  RevealRiskResultPayloadRequest$Outbound,
  RevealRiskResultPayloadRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function revealRiskResultPayloadRequestToJSON(
  revealRiskResultPayloadRequest: RevealRiskResultPayloadRequest,
): string {
  return JSON.stringify(
    RevealRiskResultPayloadRequest$outboundSchema.parse(
      revealRiskResultPayloadRequest,
    ),
  );
}
